import { jsx as r } from "react/jsx-runtime";
import { CheckCircleIcon as n } from "../../../icons/check-circle-icon.mjs";
import { CloseCircleIcon as p } from "../../../icons/close-circle-icon.mjs";
import { ToastContainer as a } from "./toast-container.mjs";
import { Toaster as m } from "react-hot-toast";
const C = ({
  className: o,
  titleClassName: i,
  buttonClassName: t,
  afterClose: e
}) => /* @__PURE__ */ r(
  m,
  {
    position: "top-center",
    containerStyle: {
      top: 80,
      right: 20
    },
    containerClassName: "[&_a]:primary-link",
    toastOptions: {
      success: {
        icon: /* @__PURE__ */ r(n, { className: "fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      },
      error: {
        icon: /* @__PURE__ */ r(p, { className: "fill-danger h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" }),
        duration: 3e3
      }
    },
    children: (s) => /* @__PURE__ */ r(
      a,
      {
        t: s,
        className: o,
        titleClassName: i,
        buttonClassName: t,
        afterClose: e
      }
    )
  }
);
export {
  C as Toast
};
